/*       */

import { name, label } from 'app/utils/designer/form/settings/common/commonBase';
import { onLoad, onChange, isVisible, isDisabled } from 'app/utils/designer/form/settings/common/commonEvents';
import { help } from 'app/utils/designer/form/settings/common/commonHelpers';
import { flexGrow } from 'app/utils/designer/form/settings/common/commonStyles';
import { required, classRequired, readOnly, staticAttribute } from 'app/utils/designer/form/settings/common/commonValidation';

const panels = settingsValues => [
    {
        header: 'Base',
        children: [
            name,
            label,
            { type: 'boolean', properties: { label: 'Hide days', name: 'properties.hideDays' } },
            { type: 'boolean', properties: { label: 'Hide hours', name: 'properties.hideHours' } },
            { type: 'boolean', properties: { label: 'Hide minutes', name: 'properties.hideMinutes' } },
            { type: 'boolean', properties: { label: 'Hide seconds', name: 'properties.hideSeconds' } },
            { type: 'boolean', properties: { label: 'Hide milliseconds', name: 'properties.hideMilliseconds' } },
        ],
    },
    {
        header: 'Events',
        expanded: true,
        children: [onLoad, onChange, isVisible, settingsValues?.viewType !== 'class' && isDisabled].filter(Boolean),
    },
    {
        header: 'Validation',
        children: [
            settingsValues?.viewType !== 'class' ? required : classRequired,
            settingsValues?.viewType === 'class' && readOnly,
            settingsValues?.viewType === 'class' && staticAttribute(settingsValues),
        ].filter(Boolean),
    },
    {
        header: 'Styles',
        children: [flexGrow],
    },
    {
        header: 'Helpers',
        children: [help],
    },
];

export default {
    defaults: { format: 'hhh:mm:ss.sss', serialize: true, withDefault: true },
    panels: settingValues => panels(settingValues),
};
